import { DEFAULT_LAYOUTS, OFFICIAL_LAYOUT } from '../../constants/defaults';

export const getDefaultReportLayoutOptions = (officialLayouts) => {
  const defaults = Object.keys(DEFAULT_LAYOUTS).map((key, index) => ({
    label: DEFAULT_LAYOUTS[key],
    value: { displayName: key, id: `unofficial-${index}` },
  }));

  const officials = officialLayouts
    .filter(({ type }) => type === 'Official')
    .map(({ id, displayName }) => ({
      label: displayName,
      value: { displayName, id },
    }));

  return [...officials, ...defaults];
};

export const deserializeDefaultLayout = (config, officialLayouts) => {
  const layoutOptions = getDefaultReportLayoutOptions(officialLayouts);
  const callBack = config.layoutTemplateId
    ? ({ value: { id } }) => id === config.layoutTemplateId
    : ({ value: { displayName } }) => displayName === config.defaultLayout;

  const defaultLayout = layoutOptions.find(callBack);

  return defaultLayout ? defaultLayout.value : layoutOptions[0].value;
};

export const serializeDefaultLayout = ({ displayName, id }) => {
  return id.startsWith('unofficial')
    ? { defaultLayout: displayName }
    : { defaultLayout: OFFICIAL_LAYOUT, layoutTemplateId: id };
};



// WEBPACK FOOTER //
// src/components/reportManagement/utils.js